module.exports = __webpack_public_path__ + "img/usefull.e940a9df.png";